export default function PHP_html_entity_decode() {
  return (
    <div>
      <h1>PHP_html_entity_decode</h1>
    </div>
  );
}
